(() => {
  function init(scope=document) {
    scope.querySelectorAll('main-product').forEach(product => {
      if(product.querySelector('.mn-gallery-purchase')?.dataset.mnGalleryReady) return;
      const toolbar=product.querySelector('.mn-gallery-purchase');
      const original=product.querySelector('.mn-product-purchase>button[type="submit"]');
      const form=original?.closest('form');
      if(!toolbar || !form) return;
      const add=toolbar.querySelector('[data-mn-gallery-add]'), buy=toolbar.querySelector('[data-mn-gallery-buy]'), error=toolbar.querySelector('[data-mn-gallery-error]');
      let busy=false;
      function sync(){add.disabled=busy||original.disabled;buy.disabled=busy||original.disabled;add.textContent=original.textContent.trim();}
      new MutationObserver(sync).observe(original,{attributes:true,childList:true,subtree:true});
      add.addEventListener('click',()=>{if(!busy&&!original.disabled){error.hidden=true;form.requestSubmit(original);}});
      buy.addEventListener('click',async()=>{
        if(busy||original.disabled||!form.reportValidity())return;
        busy=true;sync();error.hidden=true;toolbar.setAttribute('aria-busy','true');
        try{
          const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',body:new FormData(form),credentials:'same-origin',headers:{Accept:'application/json'}});
          const data=await response.json();if(!response.ok)throw Error(data.description||data.message||'Unable to add this product. Please try again.');
          window.location.assign((window.Shopify?.routes?.root||'/')+'checkout');
        }catch(e){error.textContent=e.message;error.hidden=false;}
        finally{busy=false;sync();toolbar.removeAttribute('aria-busy');}
      });
      product.dataset.mnGalleryReady='true';toolbar.dataset.mnGalleryReady='true';toolbar.hidden=false;sync();
      let attempts=0;
      const timer=setInterval(()=>{
        const gallery=product.querySelector('.main_carousel');const swiper=gallery?.swiper;
        if(swiper){swiper.allowTouchMove=true;swiper.params.allowTouchMove=true;swiper.params.simulateTouch=true;swiper.params.grabCursor=true;swiper.update();clearInterval(timer);}
        else if(++attempts>40||!product.isConnected)clearInterval(timer);
      },200);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
  let scheduled=false;
  const watch=()=>document.querySelectorAll('main-product').forEach(product=>{
    if(product.dataset.mnPurchaseWatch)return;
    product.dataset.mnPurchaseWatch='true';
    new MutationObserver(()=>{
      if(scheduled)return;scheduled=true;
      queueMicrotask(()=>{scheduled=false;init();});
    }).observe(product,{childList:true,subtree:true});
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',watch);else watch();
  document.addEventListener('shopify:section:load',watch);
})();
(() => {
 function init(scope=document){
  scope.querySelectorAll('main-product').forEach(product=>{
   if(product.dataset.mnCompactGallery) return;
   product.dataset.mnCompactGallery='true';
   let tries=0;
   const timer=setInterval(()=>{
    const gallery=product.querySelector('.main_carousel')?.swiper;
    const thumbs=product.querySelector('.thumbsslider')?.swiper;
    if(gallery){
     gallery.params.autoHeight=false;
     gallery.params.allowTouchMove=true;gallery.allowTouchMove=true;
     gallery.params.simulateTouch=true;gallery.params.grabCursor=true;
     gallery.update();
    }
    if(thumbs&&gallery){
     if(thumbs.params.direction==='vertical')thumbs.changeDirection('horizontal');
     thumbs.params.slidesPerView='auto';thumbs.params.spaceBetween=8;
     thumbs.params.breakpoints={};thumbs.params.watchSlidesProgress=true;
     thumbs.params.allowTouchMove=true;thumbs.allowTouchMove=true;thumbs.update();
     product.querySelectorAll('.thumbnail-img').forEach((thumb,i)=>{
      if(thumb.dataset.mnAccessibleThumb) return;
      thumb.dataset.mnAccessibleThumb='true';
      thumb.setAttribute('role','button');thumb.setAttribute('tabindex','0');
      thumb.setAttribute('aria-label','View product media '+(i+1));
      const select=()=>{
       const id=thumb.dataset.mediaId;
       const index=Array.from(gallery.slides).findIndex(slide=>slide.dataset.mediaId===id);
       if(index>=0)gallery.slideTo(index);
      };
      thumb.addEventListener('click',select);
      thumb.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();select();}});
     });
    }
    if((gallery&&thumbs)||++tries>40||!product.isConnected)clearInterval(timer);
   },200);
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
 document.addEventListener('shopify:section:load',event=>init(event.target));
})();

(()=> {
 function init(){
 const product=document.querySelector('main-product'),target=product?.querySelector('[data-mn-pdp-information]');
 if(!target||target.dataset.ready)return;target.dataset.ready='true';
 const share=product.querySelector('.mn-pdp-share'),heading=product.querySelector('.product__heading');
 if(heading&&share)heading.append(share);
 const button=product.querySelector('[data-mn-share]');
 button?.addEventListener('click',async()=>{
 const url=button.dataset.url,title=button.dataset.title,status=share.querySelector('[data-mn-share-status]');
 try{
 if(navigator.share){await navigator.share({title,url});return;}
 if(navigator.clipboard&&window.isSecureContext){await navigator.clipboard.writeText(url);status.textContent='Product link copied.';return;}
 }catch(error){if(error.name==='AbortError')return;}
 const input=share.querySelector('[data-mn-share-link]');input.hidden=false;input.value=url;input.focus();input.select();status.textContent='Copy this product link.';
 });
 const editorial=document.querySelector('.mn-ragi-editorial__accordions');
 function row(label,nodes){
 const details=document.createElement('details'),summary=document.createElement('summary'),body=document.createElement('div');
 summary.textContent=label;const toggle=document.createElement('span');toggle.className='mn-pdp-toggle';toggle.setAttribute('aria-hidden','true');summary.append(toggle);
 body.className='mn-pdp-information__body';nodes.forEach(node=>body.append(node));details.append(summary,body);return details;
 }
 let rows=[];
 if(editorial){rows=Array.from(editorial.querySelectorAll(':scope > details'));editorial.remove();}
 else{
 const pantry=document.querySelector('section.mn-pantry');
 if(pantry){
  pantry.querySelectorAll('.mn-pantry__description,.mn-pantry__guide,.mn-pantry-storage').forEach(container=>{
   Array.from(container.children).filter(node=>node.tagName==='H2').forEach(h=>{
    const nodes=[];let node=h.nextSibling;
    while(node&&!(node.nodeType===1&&(node.tagName==='H2'||node.classList.contains('mn-pantry-storage')))){const next=node.nextSibling;nodes.push(node);node=next;}
    if(nodes.length){rows.push(row(h.textContent.trim(),nodes));h.remove();}
   });
  });if(rows.length)pantry.remove();
 }else{
  const grain=document.querySelector('.mn-grain-story');
  if(grain){
   const desc=grain.querySelector('.mn-grain-story__description');
   if(desc)rows.push(row('Description',Array.from(desc.childNodes)));
   grain.querySelectorAll('.mn-grain-guide__panel').forEach(panel=>{
    const title=panel.querySelector('h2')?.textContent.trim()||'Product information';
    panel.querySelector('.mn-grain-guide__title')?.remove();rows.push(row(title,Array.from(panel.childNodes)));
   });if(rows.length)grain.remove();
  }
 }
 }
 // Merge only when both product-specific sections exist.
 const labelOf=details=>details.querySelector('summary')?.textContent.trim().toLowerCase();
 const ingredients=rows.find(details=>labelOf(details)==='ingredients');
 const storage=rows.find(details=>labelOf(details)==='storage instructions');
 const packTemplate=product.querySelector('template[data-mn-pack-details]');
 if(ingredients&&storage&&packTemplate){
  const ingredientBody=ingredients.querySelector('.mn-ragi-editorial__content,.mn-pdp-information__body');
  const storageBody=storage.querySelector('.mn-ragi-editorial__content,.mn-pdp-information__body');
  if(ingredientBody&&storageBody){
   const ingredientHeading=document.createElement('h3');ingredientHeading.textContent='Ingredients';
   ingredientHeading.style.cssText='font-size:1em;margin:0 0 6px';
   const storageHeading=document.createElement('h3');storageHeading.textContent='Storage Instructions';
   storageHeading.style.cssText='font-size:1em;margin:16px 0 6px';
   const combined=row('Ingredients and Storage Instructions',[]);
   const body=combined.querySelector('.mn-pdp-information__body');
   body.append(ingredientHeading,...Array.from(ingredientBody.childNodes),packTemplate.content.cloneNode(true),storageHeading,...Array.from(storageBody.childNodes));
   rows=rows.filter(details=>details!==storage).map(details=>details===ingredients?combined:details);
  }
 }
 if(rows.length){target.replaceChildren(...rows);}
 rows.forEach(details=>{const summary=details.querySelector('summary');if(!summary.querySelector('.mn-pdp-toggle')){const toggle=document.createElement('span');toggle.className='mn-pdp-toggle';toggle.setAttribute('aria-hidden','true');summary.append(toggle);}});
 if(target.children.length){product.querySelector('.product__description')?.remove();product.querySelector('#product_description')?.remove();}
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();
